import { cn } from "@/lib/utils";

// Trustpilot-style rating: green squares each holding a white star.
// Pass `size` for a fixed pixel size, or `squareClassName` (e.g. "size-4 sm:size-5")
// for responsive sizing via Tailwind breakpoints.
export function TrustStars({
  count = 5,
  size = 28,
  className,
  squareClassName,
}: {
  count?: number;
  size?: number;
  className?: string;
  squareClassName?: string;
}) {
  const responsive = Boolean(squareClassName);
  return (
    <div className={cn("inline-flex items-center gap-1", className)} aria-hidden="true">
      {Array.from({ length: 5 }).map((_, i) => (
        <span
          key={i}
          className={cn("grid place-items-center rounded-[5px]", squareClassName)}
          style={{
            ...(responsive ? {} : { width: size, height: size }),
            background: i < count ? "#00b67a" : "#dcdce6",
          }}
        >
          <svg
            width={responsive ? "66%" : size * 0.66}
            height={responsive ? "66%" : size * 0.66}
            viewBox="0 0.1 20 20"
            fill="#fff"
            className="block"
          >
            <path d="M10 1.5l2.6 5.27 5.82.85-4.21 4.1.99 5.79L10 14.77l-5.2 2.73.99-5.79-4.21-4.1 5.82-.85L10 1.5z" />
          </svg>
        </span>
      ))}
    </div>
  );
}
